import styled from "styled-components";

export const AvisoMantenimientoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const AvisoMantenimientoHeader = styled.div`
  background-color: var(--color-latex30);
  height: 54px;
  border-radius: 8px 8px 0 0;
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const AvisoMantenimientoBody = styled.div`
  padding: 20px 20px;
  max-width: 800px;
`;

export const TopMantenimiento = styled.div`
  width: 350px;
  height: 58px;
  background: var(--color-secondary-gradient);
  border-top-left-radius: 8px ;
  border-top-right-radius: 8px ;
  color: var(--color-white);
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
`;